import { atom } from 'jotai';

export const externalApiUrl = atom<string>(import.meta.env.VITE_API_URL ?? '');
